import * as React from 'react';

import {
  IconRegularApplePay,
  IconRegularGooglePay,
  IconRegularKlarna,
  IconRegularMasterCard,
  IconRegularPayPal,
  IconRegularTwint,
  IconRegularVisa,
} from '@notino/react-styleguide';

import { EShop } from '@containers/App/model';

const COMMON_PAYMENT_ICONS = {
  visa: <IconRegularVisa key="visa" />,
  mastercard: <IconRegularMasterCard key="mastercard" />,
  googlePay: <IconRegularGooglePay key="google-pay" />,
  applePay: <IconRegularApplePay key="apple-pay" />,
  paypal: <IconRegularPayPal key="paypal" />,
  klarna: <IconRegularKlarna key="klarna" />,
  twint: <IconRegularTwint key="twint" />,
};

export const PAYMENT_METHODS_BY_COUNTRY: Partial<
  Record<EShop, Array<React.ReactNode>>
> = {
  [EShop.NOTINO_IE]: [
    COMMON_PAYMENT_ICONS.applePay,
    COMMON_PAYMENT_ICONS.visa,
    COMMON_PAYMENT_ICONS.mastercard,
    COMMON_PAYMENT_ICONS.paypal,
    COMMON_PAYMENT_ICONS.googlePay,
  ],
  [EShop.NOTINO_FR]: [
    COMMON_PAYMENT_ICONS.applePay,
    COMMON_PAYMENT_ICONS.visa,
    COMMON_PAYMENT_ICONS.mastercard,
    COMMON_PAYMENT_ICONS.paypal,
    COMMON_PAYMENT_ICONS.googlePay,
    COMMON_PAYMENT_ICONS.klarna,
  ],
  [EShop.NOTINO_CH]: [
    COMMON_PAYMENT_ICONS.twint,
    COMMON_PAYMENT_ICONS.applePay,
    COMMON_PAYMENT_ICONS.visa,
    COMMON_PAYMENT_ICONS.mastercard,
    COMMON_PAYMENT_ICONS.klarna,
    COMMON_PAYMENT_ICONS.googlePay,
  ],
};

export const allowedCountries = Object.keys(
  PAYMENT_METHODS_BY_COUNTRY
) as EShop[];

export const getIconsByCountry = (shopId: EShop): React.ReactNode[] => {
  const isAndroid =
    typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

  const paymentMethods = PAYMENT_METHODS_BY_COUNTRY[shopId];

  if (!paymentMethods) {
    return [];
  }

  return paymentMethods.filter(
    (icon) => !isAndroid || icon !== COMMON_PAYMENT_ICONS.applePay
  );
};
